import { Component, OnInit, QueryList, inject } from '@angular/core';

import { CounterComponent, PortalButtonComponent } from '@coworkrz/shared/ui';
import {
  DisplayedProduct,
  ProductService,
} from '@coworkrz/products/data-access';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroArrowLeft, heroArrowRight } from '@ng-icons/heroicons/outline';
import { hugeShoppingBasketAdd03 } from '@ng-icons/huge-icons';
import { DialogRef } from '@angular/cdk/dialog';
import { Cart, CartService } from '@coworkrz/carts/data-access';
import { handleError } from '@coworkrz/core/http';
import { CurrencyPipe, ImgPlaceholderPipe } from '@coworkrz/shared/misc';
import { FormControl } from '@angular/forms';
import { Card, CardService } from '@coworkrz/cards/data-access';
import { Observable, Subscription } from 'rxjs';
import {
  SessionResponse,
  SessionService,
} from '@coworkrz/sessions/data-access';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '@coworkrz/auth/data-access';
import { User } from '@coworkrz/users/types';

@Component({
  selector: 'app-refreshment-cart',
  imports: [
    CounterComponent,
    NgIconComponent,
    PortalButtonComponent,
    ImgPlaceholderPipe,
    CurrencyPipe,
  ],
  providers: [
    provideIcons({
      heroArrowRight,
      hugeShoppingBasketAdd03,
      heroArrowLeft,
    }),
  ],
  templateUrl: './refreshment-cart.component.html',
})
export class RefreshmentCartComponent implements OnInit {
  dialogRef = inject<DialogRef<RefreshmentCartComponent>>(DialogRef);
  private cartService = inject(CartService);
  private productService = inject(ProductService);
  private sessionService = inject(SessionService);
  private cardService = inject(CardService);
  private authService = inject(AuthService);

  quantity = 1;
  total: number;

  refreshment: DisplayedProduct;
  cart: Cart = { cartItems: [], totalAmount: 0, totalItems: 0 };
  productCardElements!: QueryList<RefreshmentCartComponent>;
  quantityControl = new FormControl(this.quantity);
  isCartEmpty = true;
  card: Partial<Card>;
  card$: Observable<Partial<Card>>;
  cardNumber: string;
  cartSubscription!: Subscription;
  sessionSubscription!: Subscription;
  constructor() {
    this.cartService.cart$.subscribe((cart) => {
      this.cart = cart;
      this.isCartEmpty = cart.totalItems === 0;
    });
  }

  ngOnInit() {
    this.card$ = this.cardService.card$;
    this.cardService.card$.subscribe((card) => {
      this.card = card;
    });
  }

  getCounterNumber(product: DisplayedProduct, quantity: number) {
    this.quantity = quantity;
    this.cartService.updateItem(product, quantity, undefined, true);
  }

  getTotalForItem(quantity?: number, amount?: number) {
    if (!quantity || !amount) return 0;
    return quantity * amount;
  }

  closeModal(): void {
    this.dialogRef.close(); // Ferme la modale
  }

  handleRemoveItem(product: DisplayedProduct) {
    this.cartService.updateItem(product, 0, undefined, true);
    const productCard = this.productCardElements.find(
      (elt) => elt.refreshment.currentPrice.id === product.currentPrice.id
    );
    if (productCard) {
      productCard?.quantityControl.setValue(0);
      productCard.quantity = 0;
    }
  }

  handleSaveCart() {
    // Charge la carte d'abord
    this.authService.loadCard().subscribe({
      next: (card) => {
        const number = card?.number;

        if (!number) {
          return;
        }

        this.sessionSubscription = this.sessionService
          .getOneByCard(number)
          .subscribe({
            next: (session: SessionResponse | null) => {
              if (!session) {
                alert("Il n'y a pas de session active avec cette carte.");
              } else {
                this.saveProductToCart(session.cart.id as string, number);
              }
            },
            error: (error: HttpErrorResponse) => {
              handleError(error);
            },
          });
      },
      error: (error) => {
        console.error('Erreur lors de la récupération de la carte:', error);
        alert('Une erreur est survenue lors de la récupération de la carte.');
      },
    });
  }

  saveProductToCart(cartId: string, cardNumber: string) {
    this.cartSubscription = this.cartService
      .save(cartId, cardNumber)
      .subscribe({
        next: () => {
          alert('Items added successfully');
        },
        error: (error: HttpErrorResponse) => {
          handleError(error);
        },
      });
  }
}
